/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");

require('components/common/table-data/table-data');
const tip = require('components/base/pop/tip');
const icon = require('components/base/icon/icon');
const dropMenu = require('components/base/drop-menu/drop-menu');
require('components/common/search-menu-input/search-menu-input');

const saveAs = require('src/common/lib/FileSaver');
const { dropMenu: dropMenuEvent, inputBox: inputBoxEvent } = require('components/config/event.json');
const ajaxHttp = require('appUtil/ajaxHttp');
const { apiPath } = require('appService/api');
const store = require('appVuex/store');
const { setBreadCrumb } = require('src/common/vuex/action/common');
const { time } = require('src/common/utils/date');
require('rootPath/src/common/components/lib/filter.js');

const template = require('./order-list.tpl');
require('./order-list.scss');

const orderList = {
	template,
  store,
  
  vuex: {
    actions: {
     setBreadCrumb,
    },
    getters: {
      authorityBtnList(state){
        console.log(state);
        return state.authorityBtn.authorityBtnList;
      }
    }
  },

	data() {
		return {
			thItems: ["序号","订单号","充电站名称","枪头ID", "订单时长", "用户手机号","订单状态","创建时间","操作"],
			trItems:[],
			url: apiPath.charge.orderList,
      orStatusUrl: apiPath.charge.orderStatus,

			queryArgs:{},
      statusList:[],
			statusListObj:{},
			menuData: [
				{ text: '订单号', value: 'orderId' }, 
				{ text: '站点', value: 'spotName' },
				{ text: '枪头ID', value: 'chargerId' }
			],
			placeholder: '订单号',

			queryTime: {
				beginTime: '',
				endTime: '',
			},
			now: time(new Date().getTime()),
			orderStatus: "",
			searchObj: {},
			queryObj: {},
			queryArgs: {
				"_size": 10,
        "_index": 1
			},
      orderId: null,
      timeVal: 0
		}
	},
	ready(){
    this.getOrderStatusData();  //获取订单状态
    this.DOMEventBinding();
    //input输入框按下enter键后搜索
    /*this.$refs.searchinfo.$children[1].keyup = function() {
      this.searchData()
    }.bind(this)*/
	},

	methods: {
		searchData(val){

			this.formatQueryTime(val); //设置搜索时间
			let searchinfo = this.$refs.searchinfo.getVal();  //获取搜索框值
      let ajaxFlag = true;
      let searchValue = parseInt(searchinfo.value);
      this.searchObj = {};  //先清空下拉搜索的数据

      if (searchinfo.value) {
        let searchKey = searchinfo.key;
        switch(searchKey) {
          case 'orderId':
            if (!searchValue){
              tip("请输入数字");
              this.changeBorderColor();
              ajaxFlag=false;
            }
            this.searchObj = {'orderId': searchinfo.value};
            break;
          case 'spotName':
            if (searchValue){
              tip("请输入正确站点名称");
              this.changeBorderColor();
              ajaxFlag=false;
            }
            this.searchObj = {'spotName': searchinfo.value};
            break;
          case 'chargerId':
            if (!searchValue){
              tip("请输入数字");
              this.changeBorderColor();
              ajaxFlag=false;
            }
            this.searchObj = {'chargerId': searchinfo.value};
            break;
        }
      }
      this.queryObj = Object.assign({}, this.queryArgs, this.searchObj, {
        "startTime": this.queryTime.beginTime,
        "endTime": this.queryTime.endTime,
        "orderStatus": this.orderStatus == -1 ? null : this.orderStatus,
        "_index": 1
      });

			if (ajaxFlag) this.$refs.tableData.query(this.queryObj).fetch(this.resetQueryOpt);
		},
    resetQueryOpt() {
      this.$refs.tableData.resetQueryOpt(this.queryArgs);
    },
		formatTime(time, hasNoHM){
			let dTime = new Date(time),
					dMinutes = dTime.getMinutes();
					dMinutes = dMinutes< 10 ? "0"+ dMinutes : dMinutes;

			return ( hasNoHM ? `${dTime.getFullYear()}-${dTime.getMonth()+1}-${dTime.getDate()}  ${dTime.getHours()}:${dMinutes}` : `${dTime.getFullYear()}-${dTime.getMonth()+1}-${dTime.getDate()}`);
		},
		formatQueryTime(val){
      if (val != undefined) {
        this.timeVal = val;
      }

			if (val){
				let dTime = new Date();

				this.queryTime.endTime = this.formatTime(dTime);
				this.queryTime.beginTime = this.formatTime(dTime.setDate(dTime.getDate() - parseInt(val)));
			} else if(val === 0) {
        this.queryTime.endTime = "";
        this.queryTime.beginTime = "";
      } 
		},
    getOrderStatusData() {
      ajaxHttp(this.orStatusUrl, {})
      .then((res) => {
        
        this.statusList = this.formatObjToArr(res.data);
        this.statusListObj = res.data;
      }).catch((res) => {
      // tip(res.messsage);
      });
    },
    formatObjToArr(obj) {
      let arr = [];
      for (let i in obj){
        arr.push({"value": i, "text": obj[i]})
      }
      return arr;
    },
    changeBorderColor() {
      $(".search-menu-input .input-box-wrap").css("border-color","#ff6666");
    },
    DOMEventBinding() {
      let _seft = this;
      $(".search-menu-input input").focus(function(){
        $(".search-menu-input .input-box-wrap").css("border-color","#d6d6d6");
        // _seft.$refs.searchinfo.$children[1].value = ""; //清空输入框
      })
    }
	},
	filters: {
		filterStatus(val) {
			return (this.statusListObj[val] ? this.statusListObj[val] : "充电中")
		},
    filterChargeTime(time) {
     //毫秒转为秒
      if (!isNaN(time) && /[0]{3}$/.test(time)) {
        time = Number(time) / 1000;
      }
      let _time = Number(time);
      let hours = (_time/3600 >= 10 ? Math.floor(_time/3600) : `0${Math.floor(_time/3600)}`);
      _time -= hours * 3600;
      let minutes = (_time/60 >= 10 ? Math.floor(_time/60) : `0${Math.floor(_time/60)}`);
      _time -= minutes * 60;
      let seconds = _time >= 10 ? _time : `0${_time}`;
      
      return `${hours}时${minutes}分${seconds}秒`
    }
	},
	events:{
		[dropMenuEvent.menu.change](val){
			if (val.dispatcher.queryName === "searchStaus"){
				this.placeholder = val.optionItem.text;
        this.$refs.searchinfo.$children[1].value = ""; //清空输入框
			};
			if (val.dispatcher.queryName === "status"){
				this.orderStatus = val.value;
        this.searchData();
			}
		}
	},
}

module.exports = orderList;



// WEBPACK FOOTER //
// ./src/appBackend/components/page/charge/order-list/order-list.js